import { createModel } from "@rematch/core";
import { CustomerAddressPostalCodesState } from "src/types";

import * as api from "../api";
import { RootModel } from ".";
import { checkToken, signoutIfUnauthorized } from "./utilities";

const initialState: CustomerAddressPostalCodesState = {
  data: [],
  loading: false,
};

export const customerAddressPostalCodes = createModel<RootModel>()({
  state: initialState as CustomerAddressPostalCodesState,
  reducers: {
    fetchPending(state) {
      return { ...state, loading: true };
    },
    fetchSuccess(state, payload: { data: string[] }) {
      return {
        ...state,
        ...payload,
        loading: false,
      };
    },
    fetchFail(state) {
      return { ...state, loading: false };
    },
  },
  effects: (dispatch) => ({
    async fetchCustomerAddressPostalCodes(payload: null, rootState) {
      dispatch.customerAddressPostalCodes.fetchPending();

      const token = checkToken(rootState, () =>
        dispatch.customerAddressPostalCodes.fetchFail()
      );
      if (!token) return;

      try {
        const customerAddressPostalCodesResult = await api.fetchCustomerAddressPostalCodes(
          token
        );
        dispatch.customerAddressPostalCodes.fetchSuccess(
          customerAddressPostalCodesResult
        );
      } catch (error) {
        signoutIfUnauthorized(error, dispatch);
        dispatch.customerAddressPostalCodes.fetchFail();
        // eslint-disable-next-line no-console
        console.error(error);
      }
    },
  }),
});



// WEBPACK FOOTER //
// ./src/models/customerAddressPostalCodes.ts